import { Card, CardBody, Col } from "reactstrap";
import { NestingTitle } from "../../../../Constants/Constants";
import { NestingButtonSpan } from "../../../../Data/ButtonsData/GroupButtonData";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { NestingButton1 } from "./NestingButton1";
import { NestingButtonIcons } from "./NestingButtonIcons";

export const NestingButton = () => {
  return (
    <Col lg="6">
      <Card className="height-equal">
        <CommonCardHeader headClass="card-no-border pb-0" title={NestingTitle} span={NestingButtonSpan} tag />
        <CardBody className="btn-group-wrapper">
          <NestingButton1 />
          <NestingButtonIcons />
        </CardBody>
      </Card>
    </Col>
  );
};
